module.exports = __webpack_public_path__ + "img/marketing.7ef31226.jpg";